import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import AdminFund from 'donor-elf-web/models/admin/fund';
import AdminRoleModel from 'donor-elf-web/models/admin/role';
import AbilitiesService from 'donor-elf-web/services/abilities';
import type CachedDataset from 'donor-elf-web/services/cached-dataset';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import createUserValidation from 'donor-elf-web/validations/admin/create-user';
import { Changeset } from 'ember-changeset';
import lookupValidator from 'ember-changeset-validations';
import RSVP from 'rsvp';

export interface AdminUserAddRouteModel {
  changeset: any;
  funds: AdminFund[];
  roles: AdminRoleModel[];
  selectedFundIds: string[];
}

export default class AdminUserAddRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare cachedDataset: CachedDataset;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare store: Store;
  @service declare storeCache: any;

  beforeModel(transition: any) {
    if (this.abilities.noAbility('admin_edit_users')) {
      transition.abort();
      return;
    }
    this.navbarSettings.title = 'Add User';
  }

  async model(): Promise<AdminUserAddRouteModel> {
    let promise = RSVP.hash({
      allUsers: await this.cachedDataset.forModel('admin/user').load(),
      funds: await this.cachedDataset.forModel('admin/fund').load(),
      roles: this.storeCache.findAll('admin/role'),
    });
    let data = await promise;
    let validationInstance = createUserValidation({ allUsers: data.allUsers });
    let record = this.store.createRecord('admin/create-user', { role: 'User' });
    let changeset = Changeset(
      record,
      lookupValidator(validationInstance),
      validationInstance,
    );
    return {
      changeset: changeset,
      funds: data.funds,
      selectedFundIds: [],
      roles: data.roles,
    };
  }
}
